// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2j8NW","dragIcon":"Choice_dragIcon__NtSQA","left":"Choice_left__3e3OI","input":"Choice_input__21PiM"};